import React, { Component } from 'react';

import './GothicA1.scss';
import '../Webfont.scss';

class GothicA1Style extends Component {
  render() {
    const {input} = this.props;

    return (
      <ul className="font_style-list gothic_a1">
        <li className="weight_100">
          <span className="font_style-category">Thin 100</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_200">
          <span className="font_style-category">ExtraLight 200</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_300">
          <span className="font_style-category">Light 300</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_400">
          <span className="font_style-category">Regular 400</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_500">
          <span className="font_style-category">Medium 500</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_600">
          <span className="font_style-category">SemiBold 600</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_700">
          <span className="font_style-category">Bold 700</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_800">
          <span className="font_style-category">ExtraBold 800</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
        <li className="weight_900">
          <span className="font_style-category">Black 900</span>
          <p className="font_style-preview">{input}</p>
          {/* <button type="button" className="font_style_select-btn">폰트 선택</button> */}
        </li>
      </ul>
    );
  }
}

export default GothicA1Style;